import Service from '../Service'
import {http} from '../config'

export default class FluxoBancarioService extends Service{

    constructor(){
        super('fluxobancario');
    }

    // ListarComFiltro(page, pageSize, sortBy, desc, search, columns, filter){
        
    //     let parametros = this.GetParamentroPaginacaoOrdenacao(page, pageSize, sortBy, desc, search, columns);

    //     if (filter) {
    //         parametros += '&$filter=';

    //         if (filter.tipo){
    //             parametros += `tipo eq ${filter.tipo} and `;
    //         }

    //         parametros += `bancoId eq ${filter.bancoId} and `;
    //         parametros += `data ge ${filter.dataInicial} and `;
    //         parametros += `data le ${filter.dataFinal}`;
    //     }
        
    //     parametros += '&$orderby=data';

    //     return http.get(`${this._nomeControle}${parametros}`);
    // }

    ListarComFiltro(filter){
        
        let parametros = '';
        parametros += `?dataInicial=${filter.dataInicial}`;
        parametros += `&dataFinal=${filter.dataFinal}`;

        if (filter.bancoId){
            parametros += `&bancoId=${filter.bancoId}`;
        }

        if (filter.codigoInicio > 0){
            parametros += `&codigoInicial=${filter.codigoInicio}`;
        }

        if (filter.codigoFim > 0){
            parametros += `&codigoFinal=${filter.codigoFim}`;
        }

        if (filter.tipo){
            parametros += `&tipo=${filter.tipo}`;
        }

        if (filter.doadorId) {
            parametros += `&doadorId=${filter.doadorId}`;
        }

        if (filter.fornecedorId != null && filter.fornecedorId > "0") {
            parametros += `&fornecedorId=${filter.fornecedorId}`;
        }

        return http.get(`${this._nomeControle}/extrato${parametros}`);
    }

    Transferir(modelo){
        return http.post(`${this._nomeControle}/transferir`, modelo);
    }

    Reabrir(id){
        return http.put(`${this._nomeControle}/${id}/reabrir`);
    }

    Relatorio(filter){

        return http.get(`${this._nomeControle}/lancamentocontabil`, {
            params: {
                dataInicial: filter.dataInicial,
                dataFinal: filter.dataFinal,
                listar: filter.listar
            }
        });
    }

    ObterBalancete(dataInicial, dataFinal, projetoId){
        return http.get(`${this._nomeControle}/obterBalancete`, {
            params: {
                dataInicial: dataInicial,
                dataFinal: dataFinal,
                projetoId: projetoId
            }
        });
    }

    DetalharBalancete(planoContasId, planoContasItemId, dataInicial, dataFinal, projetoId){
        return http.get(`${this._nomeControle}/detalharBalancete`, {
            params: {
                planoContasId: planoContasId,
                planoContasItemId: planoContasItemId,
                dataInicial: dataInicial,
                dataFinal: dataFinal,
                projetoId: projetoId            
            }
        });
    }

    RelatorioBalanceteListagem(dataInicial, dataFinal){
        return http.get(`${this._nomeControle}/relatoriobalancetelistagem`, {
            params: {
                dataInicial: dataInicial,
                dataFinal: dataFinal
            }
        });
    }

    Grafico(){
        return http.get(`${this._nomeControle}/grafico`)
    }

    TotalDisponivel(){
        return http.get(`${this._nomeControle}/TotalDisponivel`)
    }

    Conciliar(item){
        return http.post(`${this._nomeControle}/Conciliar`, item);
    }

    LerArquivoConciliacao(arquivo){
        let bodyFormData = new FormData();
        bodyFormData.append('arquivo', new Blob([arquivo]), arquivo.name);

        return http.post(`${this.getNomeControle()}/LerArquivoConciliacao`, bodyFormData, {
            headers: {'Content-Type': 'multipart/form-data' }            
        });
    }
}